const protocol = window.location.protocol;
const host = window.location.host;
const baseURL = `${protocol}//${host}`;

const userLanguage = navigator.language || navigator.userLanguage;
let language = userLanguage.startsWith("es") ? "es" : "en";

const switchLanguage = (lang) => {
  const currentUrl = window.location.href;
  let newUrl;

  if (lang === "es") {
    if (!currentUrl.includes("/es")) {
      newUrl = baseURL + "/es" + currentUrl.replace(baseURL, "");
      window.location.href = newUrl;
    } else {
      updateLinks(lang);
    }
  } else {
    if (currentUrl.includes("/es")) {
      newUrl = currentUrl.replace("/es", "");
      window.location.href = newUrl;
    } else {
      updateLinks(lang);
    }
  }

  localStorage.setItem("language", lang);
};

const updateLinks = (lang) => {
  const links = document.querySelectorAll("a");
  links.forEach((link) => {
    const href = link.getAttribute("href");
    if (href && href.startsWith("/")) {
      let newHref;
      if (lang === "en") {
        newHref = href.replace("/es", "");
      } else {
        if (!href.startsWith("/es")) {
          newHref = `/es${href}`;
        } else {
          newHref = href;
        }
      }
      link.setAttribute("href", newHref);
    }
  });
};

const initializeLanguageSetting = () => {
  const storedLanguage = localStorage.getItem("language");

  if (storedLanguage) {
    language = storedLanguage;
  }

  switchLanguage(language);

  const switcherLanguage = document.querySelector(".header__language");
  if (switcherLanguage) {
    switcherLanguage.value = language;
    switcherLanguage.addEventListener("change", (event) => {
      const selectedLanguage = event.target.value;
      switchLanguage(selectedLanguage);
    });
  }
};

initializeLanguageSetting();
